import SingleOptionIcon from "@mui/icons-material/Check";
import MultiOptionIcon from "@mui/icons-material/Checklist";
import TextOptionIcon from "@mui/icons-material/TextsmsOutlined";
import InfoOptionIcon from "@mui/icons-material/AnnouncementOutlined";
import OrderOptionIcon from "@mui/icons-material/FormatListNumbered";

export const SM_SVC_ERROR_CODE = {
    USERNAME_ALREADY_EXISTS: 1000,
    USER_NOT_FOUND: 10001,
    INVALID_CREDENTIALS: 1002,
    REQUIRED_2FA_AUTH: 1003,
    INVALID_CONTACT_INFO: 1004,
    INVALID_OTP: 1005,
    EXPIRED_2FA_TOKEN: 1006,
    EXCEED_2FA_RESEND: 1007,
    FATAL_ERROR: 2000
}

export const RESPONSE_STATUS_CODE = {
    SUCCESS: 200,
    CREATED: 201,
    FORBIDDEN: 403
}


export const PARTITION = {
    HOME: "/v1",
    QUIZ: "/v1/quiz",
    PRIVATE: "/v1/pvt",
    PVT_LAYOUTS: "/v1/pvt/layouts",
    PVT_BUILDER: "/v1/pvt/builder",
    PVT_QUIZ: "/v1/pvt/quiz"
}

export const ANSWER_TEMPLATES = {
    RADIO: { key: "RADIO", label: "Single Option", color:"#ef687f", icon: <SingleOptionIcon /> },//#FF8FA2
    CHECK: { key: "CHECK", label: "Multiple Option", color:"#65db68", icon: <MultiOptionIcon /> },//#89E68B
    ORDER: { key: "ORDER", label: "Order Answers", color:"#E06C00", icon: <OrderOptionIcon /> },//#FFCE85
    TEXT: { key: "TEXT", label: "Type Answer", color:"#1868DB", icon: <TextOptionIcon /> },//#96DEFE
    INFO: { key: "INFO", label: "Information", color:"#2898BD", icon: <InfoOptionIcon /> }//#CFCBCB
}

export const MEDIA_TYPES = {
    IMAGE: "image",
    AUDIO: "audio",
    VIDEO: "video",
    DOCUMENT: "document",
}